import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleDirectory } from "../actions";

const DirectoriesTable = () => {
  const dispatch = useDispatch();
  const directories = useSelector(state => state.directories)

  return (
    <table className="table directories-table">
      <tbody>
        {directories.map((directory) => (
          <tr className="directory-row" key={directory.id}>
            <td>
              <div
                className={`icheckbox_square-orange icheck-item ${directory.mobile_enabled ? 'checked' : ''}`}
                onClick={() => dispatch(toggleDirectory(directory.id))}
              >
                <input
                  id={`checkbox${directory.id}`}
                  className="i-checks icheck-input"
                  type="checkbox"
                  checked={directory.mobile_enabled}
                  readOnly
                />
              </div>
            </td>
            <td>{directory.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DirectoriesTable;